import * as React from "react";
import { useNavigate } from "react-router-dom";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import Grid from "@mui/material/Grid";
import { Typography } from "@mui/material";
import DashboardLayoutCustom2 from "examples/LayoutContainers/DashboardLayoutCustom2";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useEffect, useState, useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getProfileAysnc } from "features/actions/auth";
import Loader from "assets/loader/loader";
import toast from "react-hot-toast";
import { resetGetScrapeUrl } from "features/reducers/auth";
import { chatbotCompareMeAsync } from "features/actions/auth";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";

function CompareMe() {
    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 550,
        bgcolor: "background.paper",
        borderRadius: "12px",
        boxShadow: 24,
        p: 4,
        textAlign: "center",
        py: 5,
    };

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { getprofile, getScrapeUrl, getScrapeData, compareMe } = useSelector(
        (state) => state.auth
    );
    const [predictions, setPredictions] = useState([]);
    const [placePredictions, setPlacePredictions] = useState([]);
    const [urlFieldVisible, setUrlFieldVisible] = useState(false);
    const [restroOptionsPopUp, setRestroOptionsPopUp] = useState(false);
    const [restroOptions, setRestroOptions] = useState([]);
    const [searchForAddress, setSearchForAddress] = useState(false);
    const [changeCommonId, setChangeCommonId] = useState(false);
    const [loading, setLoading] = useState(false);
    const [restroAddressOptions, setRestroAddressOptions] = useState([]);
    const [restroAddressOptionsPopUp, setRestroAddressOptionsPopUp] =
        useState(false);
    const [values, setValues] = useState([
        {
            restaurant_name: "",
            business_address: "",
            yelp_link: "",
            facebook_link: "",
            google_link: "",
            instagram_link: "",
            website_link: ""
        },
    ]);

    const [errors, setErrors] = useState([
        {
            restaurant_name: "",
            business_address: "",
            yelp_link: "",
            facebook_link: "",
            google_link: "",
            instagram_link: "",
            website_link: ""
        },
    ]);

    useLayoutEffect(() => {
        handleReset();
    }, []);

    const handleReset = () => {
        dispatch(resetGetScrapeUrl());
        setUrlFieldVisible(false);
        setValues([
            {
                id: "",
                restaurant_name: "",
                business_address: "",
                yelp_link: "",
                facebook_link: "",
                google_link: "",
                instagram_link: "",
                website_link: ""
            },
        ]);
        dispatch(getProfileAysnc());
    };

    // Form validation
    // const validateSearchForm = () => {
    //     let isValid = true;
    //     const newErrors = [...errors];

    //     values.forEach((value, index) => {
    //         const newError = { ...newErrors[index] };

    //         if (!value.restaurant_name.trim()) {
    //             newError.restaurant_name = "Business name is required";
    //             isValid = false;
    //         } else {
    //             newError.restaurant_name = "";
    //         }

    //         if (!value.business_address.trim()) {
    //             newError.business_address = "Business address is required";
    //             isValid = false;
    //         } else {
    //             newError.business_address = "";
    //         }

    //         newErrors[index] = newError;
    //     });
    //     setErrors(newErrors);
    //     return isValid;
    // };
    // ------------------------------------------------------------------------- //

    useEffect(() => {
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyD_vGGVm-ATDIapeInR3hPNzRHAMkKnqfw&libraries=places&callback=initAutocomplete`;
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    useEffect(() => {
        window.initAutocomplete = () => {
            const input = document.getElementById("address-input");
            if (input) {
                const autocomplete = new window.google.maps.places.Autocomplete(input);
                autocomplete.addListener("place_changed", () =>
                    handlePlaceChanged(autocomplete)
                );
            }
        };
        window.initAutocomplete();
        return () => {
            delete window.initAutocomplete;
        };
    }, [values]);

    const handlePlaceChanged = (autocomplete) => {
        const place = autocomplete.getPlace();
        const selectedText = place?.formatted_address;
        const index = 0;
        handleRestroAddress(selectedText, index);
    };

    // auto search place based on input

    const searchRestro = (inputValue) => {
        const service = new window.google.maps.places.AutocompleteService();
        service.getPlacePredictions({ input: inputValue }, (predictions) => {
            if (predictions) {
                setPlacePredictions(predictions);
            }
        });
    };

    useEffect(() => {
        let placeOptions = [];
        if (placePredictions?.length > 0) {
            placePredictions?.map((ele) => {
                placeOptions.push(ele?.structured_formatting?.main_text);
            });
            setRestroOptions(placeOptions);
            setRestroOptionsPopUp(true);
        } else {
            setRestroOptions([]);
        }
    }, [placePredictions]);

    // --------------------------------------------------------------------------------------- //

    // auto search address based on restaurant name provided

    const searchRestroAddress = (inputValue) => {
        if (!window.google || !window.google.maps || !window.google.maps.places) {
            console.error("Google Maps API is not loaded.");
            return;
        }
        const service = new window.google.maps.places.PlacesService(
            document.createElement("div")
        );
        const request = {
            query: inputValue,
            region: "US",
            types: ["restaurant", "bar"],
        };
        service.textSearch(request, (results, status) => {
            if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                const formattedAddresses = results?.map(
                    (result) => result?.formatted_address
                );
                setPredictions(formattedAddresses);
            }
        });
    };

    useEffect(() => {
        let restroAddress = [];
        if (predictions?.length > 0) {
            predictions?.map((ele) => {
                restroAddress.push(ele);
            });
            setRestroAddressOptions(restroAddress);
            setRestroAddressOptionsPopUp(true);
        } else {
            setRestroAddressOptions([]);
        }
    }, [predictions]);

    // ------------------------------------------------------------------------------------------------ //

    const inputHandler = (fieldName, index, e) => {
        const updatedValues = [...values];
        updatedValues[index] = {
            ...values[index],
            [fieldName]: e.target.value,
        };

        const newErrors = [...errors];
        const newError = { ...newErrors[index] };
        if (fieldName === "restaurant_name") {
            if (!e.target.value.trim()) {
                newError.restaurant_name = "Business name is required";
                setRestroAddressOptionsPopUp(false);
                setRestroOptionsPopUp(false);
                setUrlFieldVisible(false);
                dispatch(resetGetScrapeUrl());
            } else {
                newError.restaurant_name = "";
                searchRestro(values?.[0]?.restaurant_name);
                setUrlFieldVisible(false);
                dispatch(resetGetScrapeUrl());
                setSearchForAddress(false);
            }

            // Reset specific fields
            updatedValues[index] = {
                ...updatedValues[index],
                business_address: "",
                yelp_link: "",
                facebook_link: "",
                google_link: "",
                instagram_link: "",
                website_link: ""
            };
        }

        if (fieldName === "business_address") {
            if (!e.target.value.trim()) {
                newError.business_address = "Business address is required";
                setRestroAddressOptionsPopUp(false);
                setUrlFieldVisible(false);
                dispatch(resetGetScrapeUrl());
                setRestroOptionsPopUp(false);
            } else {
                newError.business_address = "";
                setUrlFieldVisible(false);
                dispatch(resetGetScrapeUrl());
                setRestroAddressOptionsPopUp(false);
                setRestroOptionsPopUp(false);
            }

            updatedValues[index] = {
                ...updatedValues[index],
                yelp_link: "",
                facebook_link: "",
                google_link: "",
                twitter_link: "",
            };
        }

        newErrors[index] = newError;
        setErrors(newErrors);
        setValues(updatedValues);
    };

    // useEffect(() => {
    //     if (getprofile?.userProfile?.id) {
    //         setUserId(getprofile?.userProfile?.id);
    //         setUserEmail(getprofile?.userProfile?.email);
    //         setUserFirstName(getprofile?.userProfile?.first_name);
    //     }
    // }, [getprofile?.userProfile?.id]);

    const handleRestro = (name, index) => {
        setRestroOptionsPopUp(false);
        const updatedValues = values.map((item, i) => {
            if (i === index) {
                return {
                    ...item,
                    restaurant_name: name,
                };
            } else {
                return item;
            }
        });
        setValues(updatedValues);
        setRestroAddressOptionsPopUp(false);
        setSearchForAddress(true);
    };

    useEffect(() => {
        if (searchForAddress) {
            searchRestroAddress(values?.[0]?.restaurant_name);
        }
    }, [searchForAddress]);

    const handleRestroAddress = (name, index) => {
        const restaurantName = values[index]?.restaurant_name;
        const concatenatedName = restaurantName
            ? `${restaurantName}, ${name}`
            : name;

        const updatedValues = values.map((item, i) => {
            if (i === index) {
                return {
                    ...item,
                    business_address: name,
                    address: concatenatedName,
                };
            } else {
                return item;
            }
        });
        setValues(updatedValues);
        setRestroAddressOptionsPopUp(false);
    };

    const handleSubmit = async () => {
        const restaurant_name = values[0]?.restaurant_name?.trim();
        const business_address = values[0]?.business_address?.trim();
        if (!restaurant_name || !business_address) {
            toast.error("All fields are required");
            return;
        }
        const businessId = localStorage.getItem("common_id");
        const payload = { business_id: businessId, compare_business_name: restaurant_name, compare_business_address: business_address }
        try {
            setLoading(true);
            await dispatch(chatbotCompareMeAsync(payload));
            setLoading(false);
        } catch (error) {
            console.error("Error in handleSubmit:", error);
            toast.error("Something went wrong. Please try again.");
            setLoading(false);
        }
    };

    useEffect(() => {
        if (
            Object.keys(getScrapeUrl)?.length != 0 &&
            getScrapeUrl?.status_code == 200 &&
            urlFieldVisible
        ) {
            toast.success("Please verify the autopopulate Urls.");
            setValues([{ ...values[0], ...getScrapeUrl?.data }]);
        } else if (getScrapeUrl?.status_code == 400) {
            toast.error("Could not find URls. Try again later");
        }
    }, [getScrapeUrl?.data, urlFieldVisible]);

    useEffect(() => {
        if (changeCommonId && getScrapeData?.status_code == 202) {
            const businessId = 0;
            localStorage.setItem("common_id", businessId?.toString());
            navigate("/scrape-page");
            toast.success("Reviews syncing initiated.");
            setUrlFieldVisible(false);
            dispatch(resetGetScrapeUrl());
            setLoading(false);
        } else if (getScrapeData?.status_code == 400) {
            toast.error("This business is already added.");
        } else if (getScrapeData?.status_code == 500) {
            toast.error("Couldn't syncing business.");
        }
    }, [changeCommonId, getScrapeData]);



    return (
        <MDBox sx={{ backgroundColor: "#f9f9f9", minHeight: "100vh" }}>
            <DashboardLayoutCustom2>
                {loading && <Loader />}
                <DashboardNavbar />


                <MDBox sx={{ px: "1rem" }}>
                    {values?.map((value, index) => {
                        return (
                            <MDBox
                                sx={{
                                    py: 1,
                                    borderRadius: "20px",
                                    height: "auto",
                                    boxShadow: "0px 1px 6px rgba(0,0,0,0.1)",
                                    backgroundColor: "#ffffff",
                                    mb: 4,
                                }}
                                key={index}
                            >
                                <MDBox sx={{ borderBottom: "1px solid #E1EAFF", px: 2, py: 1 }}>
                                    <MDTypography
                                        mt={2}
                                        mb={2}
                                        sx={{
                                            color: "#292929",
                                            fontFamily: "Urbanist",
                                            fontSize: "24px",
                                            fontWeight: 700,
                                            lineHeight: "28.8px",
                                        }}
                                    >
                                        Provide details for business that you want to compare with.
                                    </MDTypography>
                                </MDBox>

                                <MDBox sx={{ px: 2, py: 2 }}>
                                    <Grid container columnSpacing={5} rowSpacing={2}>
                                        <Grid item xs={12} md={6} lg={4}>
                                            <MDBox>
                                                <MDTypography
                                                    variant="subtitle2"
                                                    fontWeight="regular"
                                                    sx={{ color: "#212121" }}
                                                    mt={1}
                                                >
                                                    Business Name
                                                    <MDBox sx={{ color: "red" }} component="span">
                                                        *
                                                    </MDBox>
                                                </MDTypography>
                                                <MDInput
                                                    type="text"
                                                    placeholder="Business name"
                                                    value={value?.restaurant_name}
                                                    error={!!errors[index]?.restaurant_name}
                                                    onChange={(e) =>
                                                        inputHandler("restaurant_name", index, e)
                                                    }
                                                    fullWidth
                                                    sx={{
                                                        "& .MuiInputBase-root": {
                                                            borderRadius: "45px",
                                                            paddingRight: "41px",
                                                        },
                                                        "& .MuiOutlinedInput-root": {
                                                            borderRadius: "45px",
                                                        },
                                                    }}
                                                />
                                            </MDBox>
                                            {errors[index]?.restaurant_name ? (
                                                <MDTypography px={1} variant="button" color="error">
                                                    {errors[index]?.restaurant_name}
                                                </MDTypography>
                                            ) : null}

                                            {/* first */}
                                            {restroOptionsPopUp && (
                                                <div
                                                    style={{
                                                        height: "250px",
                                                        overflowY: "auto",
                                                        position: "absolute",
                                                        left: "55px",
                                                        background: "#fff",
                                                        zIndex: "999",
                                                        padding: "10px",
                                                        marginTop: "10px",
                                                        border: "1px solid #f2f2f2",
                                                        width: "29%",
                                                    }}
                                                    className="address"
                                                >
                                                    {restroOptions?.length > 0 ? (
                                                        restroOptions.map((restroOption) => (
                                                            <li
                                                                key={restroOption}
                                                                style={{
                                                                    fontSize: "14px",
                                                                    cursor: "pointer",
                                                                    marginTop: "5px",
                                                                    borderBottom: "1px solid #ccc", // Add a horizontal line at the bottom
                                                                    paddingBottom: "5px",
                                                                }}
                                                                onClick={() =>
                                                                    handleRestro(restroOption, index)
                                                                }
                                                            >
                                                                {restroOption}
                                                            </li>
                                                        ))
                                                    ) : (
                                                        <p
                                                            style={{
                                                                fontSize: "14px",
                                                                cursor: "pointer",
                                                                marginTop: "5px",
                                                                paddingBottom: "5px",
                                                            }}
                                                        >
                                                            No Address found
                                                        </p>
                                                    )}
                                                </div>
                                            )}

                                            {/* second  */}
                                            {restroAddressOptionsPopUp && (
                                                <p
                                                    style={{
                                                        fontSize: "14px",
                                                        marginTop: "20px",
                                                        marginLeft: "10px",
                                                        color: "#000",
                                                    }}
                                                >
                                                    Based on our database search, we've compiled a list of
                                                    businesses associated with the entered business name.
                                                </p>
                                            )}

                                            {restroAddressOptionsPopUp && (
                                                <div
                                                    style={{
                                                        height: "250px",
                                                        overflowY: "auto",
                                                        position: "absolute",
                                                        left: "55px",
                                                        background: "#fff",
                                                        zIndex: "999",
                                                        padding: "10px",
                                                        marginTop: "10px",
                                                        border: "1px solid #f2f2f2",
                                                        width: "29%",
                                                    }}
                                                    className="address"
                                                >
                                                    {restroAddressOptions?.length > 0 ? (
                                                        restroAddressOptions.map((addressOption) => (
                                                            <li
                                                                key={addressOption}
                                                                style={{
                                                                    fontSize: "14px",
                                                                    cursor: "pointer",
                                                                    marginTop: "5px",
                                                                    borderBottom: "1px solid #ccc",
                                                                    paddingBottom: "5px",
                                                                }}
                                                                onClick={() =>
                                                                    handleRestroAddress(addressOption, index)
                                                                }
                                                            >
                                                                {addressOption}
                                                            </li>
                                                        ))
                                                    ) : (
                                                        <p
                                                            style={{
                                                                fontSize: "14px",
                                                                cursor: "pointer",
                                                                marginTop: "5px",
                                                                paddingBottom: "5px",
                                                            }}
                                                        >
                                                            No Address found
                                                        </p>
                                                    )}
                                                </div>
                                            )}
                                        </Grid>
                                        <Grid item xs={12} md={6} lg={4}>
                                            <MDBox sx={{ position: "relative" }}>
                                                <MDTypography
                                                    variant="subtitle2"
                                                    fontWeight="regular"
                                                    sx={{ color: "#212121" }}
                                                    mt={1}
                                                >
                                                    Business Address
                                                    <MDBox sx={{ color: "red" }} component="span">
                                                        *
                                                    </MDBox>
                                                </MDTypography>
                                                <MDInput
                                                    type="text"
                                                    placeholder="Business address"
                                                    id="address-input"
                                                    value={value?.business_address}
                                                    error={!!errors[index]?.business_address}
                                                    onChange={(e) =>
                                                        inputHandler("business_address", index, e)
                                                    }
                                                    onFocus={() => {
                                                        setRestroOptionsPopUp(false);
                                                        setRestroAddressOptionsPopUp(false);
                                                    }}
                                                    fullWidth
                                                    sx={{
                                                        "& .MuiInputBase-root": {
                                                            borderRadius: "45px",
                                                            paddingRight: "41px",
                                                        },
                                                        "& .MuiOutlinedInput-root": {
                                                            borderRadius: "45px",
                                                        },
                                                    }}
                                                />
                                                {errors[index]?.business_address ? (
                                                    <MDTypography px={1} variant="button" color="error">
                                                        {errors[index]?.business_address}
                                                    </MDTypography>
                                                ) : null}
                                            </MDBox>
                                        </Grid>
                                        <MDBox
                                            sx={{
                                                display: "flex",
                                                justifyContent: "flex-end",
                                                ml: "70px",
                                            }}
                                        >
                                            <MDBox
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "end",
                                                    justifyContent: "end",
                                                    gap: "15px",
                                                    flexDirection: "row",
                                                    "@media(max-width:786px)": {
                                                        flexDirection: "column-reverse",
                                                        alignItems: "start",
                                                    },
                                                    pt: 5,
                                                }}
                                            >
                                                <MDButton
                                                    variant="gradient"
                                                    color="info"
                                                    sx={{
                                                        paddingLeft: "5rem",
                                                        paddingRight: "5rem",
                                                        paddingTop: "1rem",
                                                        paddingBottom: "1rem",
                                                        borderRadius: "45px",
                                                    }}
                                                    onClick={handleSubmit}
                                                >
                                                    submit
                                                </MDButton>


                                            </MDBox>
                                        </MDBox>
                                    </Grid>
                                    <MDBox>
                                        <Typography
                                            sx={{
                                                color: "#333",
                                                fontSize: "16px",
                                                lineHeight: "1.6",
                                               
                                            }}
                                            padding={3}
                                            className="markdown-body"
                                            backgroundColor="transparent !important"
                                        >
                                            {(compareMe?.message || (typeof compareMe === "string" && compareMe)) && (
                                                <Markdown
                                                    remarkPlugins={[remarkGfm]}
                                                    rehypePlugins={[rehypeRaw]}
                                                >
                                                    {compareMe?.message || compareMe}
                                                </Markdown>
                                            )}
                                        </Typography>
                                    </MDBox>
                                </MDBox>
                            </MDBox>
                        );
                    })}
                </MDBox>
            </DashboardLayoutCustom2>
        </MDBox>
    );
}

export default CompareMe;
